"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotProduct = exports.elementWiseProduct = void 0;
const arraySum_1 = require("./arraySum");
const elementWiseProduct = (a, b) => a.map((_, i) => a[i] * b[i]);
exports.elementWiseProduct = elementWiseProduct;
const dotProduct = (a, b) => (0, arraySum_1.arraySum)((0, exports.elementWiseProduct)(a, b));
exports.dotProduct = dotProduct;
